
export type ResolvablePromise<T> = Promise<T> & {
    resolve: (data: T) => void;
    reject: (data: any) => void;
};

export type ResolvablePromiseOptions = {
    abortSignal?: AbortSignal;
};

export function resolvablePromise<T>(options?: ResolvablePromiseOptions): ResolvablePromise<T> {
    const abortSignal = options?.abortSignal;
    let resolve: ((data: T) => void);
    let reject: ((data: any) => void);

    const promise = new Promise<T>((res, rej) => {
        resolve = res;
        reject = rej;
    }) as ResolvablePromise<T>;

    if (abortSignal) {
        promise.resolve = (data: T) => {
            if (!abortSignal.aborted) {
                resolve!(data);
            }
        };
    } else {
        promise.resolve = resolve!;
    }

    promise.reject = reject!;

    return promise;
}

export function abortablePromise<T>(promise: Promise<T>, signal: AbortSignal): Promise<T> {
    return promise.then(data => {
        return new Promise(res => {
            if(!signal.aborted) {
                res(data);
            }
        });
    });
}